/**
 * Regra ÚNICA do modelo de abertura da mesa (v5), compartilhada entre o
 * NewTicketDialog (app) e o PortalNewTicket (portal): ao trocar de mesa, a
 * descrição só é substituída quando está "intacta" — vazia (após trim) OU
 * exatamente igual ao modelo da mesa anterior.
 *
 * @returns o novo valor da descrição, ou null para "não mexer" — texto
 * digitado pelo usuário nunca é sobrescrito.
 */
export function applyOpeningTemplate(
  current: string,
  prevTemplate: string | null,
  nextTemplate: string | null
): string | null {
  const untouched = current.trim() === '' || current === prevTemplate;
  if (!untouched) return null;
  return nextTemplate ?? '';
}
